import styled from 'styled-components';

export const PageHeader = styled.div`
  background: #242424;
  min-height: 10.6rem;
  max-height: 10.6rem;
  padding: 0 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  width: 100%;

  position: sticky;
  top: 0;
`;

export const PageHeaderBackButton = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 25px;
  align-items: center;
  justify-content: center;
  color: #ffdf22;
  cursor: pointer;
`;

export const PageHeaderButtonsContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 2rem;

  svg {
    color: #ffdf22;
    cursor: pointer;
  }
`;

export const PageHeaderBackButtonLabel = styled.div`
  font-weight: bold;
  padding-left: 5px;
  text-transform: uppercase;
  letter-spacing: 1.25px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const PageHeaderSaveButton = styled.button`
  font-weight: bold;
  font-size: 18px;

  width: 20%;
  height: 45px;

  background: transparent linear-gradient(97deg, #ffdf22 0%, #ffd503 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 50px;

  @media (max-width: 768px) {
    width: 40%;
  }

  @media (max-width: 1280px) {
    width: 30%;
  }

  &:hover {
    opacity: 0.85;
    transition: 0.3s;
  }
`;

export const Container = styled.div``;

export const FindedStudentMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3rem;
  width: 80%;

  h3 {
    font-size: 2.5rem;
  }

  div {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;

    svg {
      cursor: pointer;
    }
  }
`;

export const SearchStudentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3rem;

  h4 {
    font-size: 2rem;
  }

  div {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;

    svg {
      cursor: pointer;
    }
  }
`;

export const FormContainer = styled.form`
  padding: 36px 31px;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const FieldsWrapper = styled.div`
  /* display: grid;
  grid-template-columns: 1fr 1fr;
  max-width: 68.4rem; */
  display: flex;
  flex-direction: column;
  gap: 0 4.4rem;

  @media (max-width: 1120px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 425px) {
    width: 100%;
  }
`;

export const FieldSet = styled.fieldset`
  display: flex;
  flex-direction: column;
  border: none;
  margin-bottom: 28px;

  width: 350px;

  @media (max-width: 425px) {
    width: 100%;
  }
`;

export const FormLabel = styled.label`
  font-size: 15px;
  font-weight: bold;
  color: #fff;
  padding: 0 17px;
  margin-bottom: 5px;
`;

export const ImageLabel = styled.label`
  width: 14.5rem;
  cursor: pointer;

  p {
    font-size: 15px;
    font-weight: bold;
    color: #fff;
    padding: 0 17px;
    margin-bottom: 5px;
  }

  transition: filter 0.2s;

  :hover {
    filter: brightness(0.9);
  }
`;

export const ImageInput = styled.input.attrs({ type: 'file' })`
  display: none;
`;

export const Image = styled.img`
  width: 141px;
  height: 141px;
  border-radius: 4px;
  background: #aeaeae;
`;

interface RadioOptionProps {
  isSelected: boolean;
}

export const RadioInput = styled.button.attrs({
  type: 'button',
})<RadioOptionProps>`
  display: flex;
  align-items: center;
  background: none;

  padding: 0 1.7rem;
  margin-bottom: 0.6rem;

  .radio {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 2.2rem;
    height: 2.2rem;
    border: 1px solid #fff;
    border-radius: 50%;

    background: transparent;

    margin-right: 0.5rem;

    transition: ${({ theme }) => theme.transition.default};

    .filled {
      width: 1.4rem;
      height: 1.4rem;
      border-radius: inherit;

      background: ${({ isSelected }) => (isSelected ? '#fff' : '#000')};
    }
  }

  > p {
    color: #fff;
    transition: ${({ theme }) => theme.transition.default};
  }

  &:hover {
    .radio {
      border-color: #fff;
    }

    > p {
      color: #fff;
    }
  }
`;
